import { IGlobalState } from 'store';

export const selectors = {
	getActivityId: (state: IGlobalState) => state.followUps.update.activityId,
	getFollowUpId: (state: IGlobalState) => state.followUps.update.followUpId,
	getInitAction: (state: IGlobalState) => state.followUps.update.init,
	getUpdateAction: (state: IGlobalState) => state.followUps.update.update,
	getOpen: (state: IGlobalState) => state.followUps.update.open,
	getFollowUps: (state: IGlobalState) => state.followUps.update.followUps,
	getOpportunityId: (state: IGlobalState) => state.followUps.update.opportunityId,
	getOnSuccess: (state: IGlobalState) => state.followUps.update.onSuccess,
	form: {
		getFollowUpResult: (state: IGlobalState) => state.followUps.update.form.formData.followUpResult
	}
};
